import { PULL_REVEAL_PX, PULL_THRESHOLD_PX } from '@Guidelines/Shell/PullToRefresh/resolvePullDistance';

/** Maps the damped pull distance to 0 at the reveal point and 1 at the refresh threshold. */
const resolveRevealProgress = (distance: number): number => {
	const progress = (distance - PULL_REVEAL_PX) / (PULL_THRESHOLD_PX - PULL_REVEAL_PX);

	return Math.min(Math.max(progress, 0), 1);
};

export default resolveRevealProgress;
